<template>
    <div
        :class="`menu-item ${isActive ? 'active' : ''}`"
        @mouseover="$emit('mouseover')"
        @mouseleave="$emit('mouseleave')"
    >
        <typo name="menu-16-normal">
            <slot></slot>
        </typo>
    </div>
</template>

<script>
import Vue from "vue";
export default Vue.extend({
    props: ["isActive"],
});
</script>

<style lang="sass" scoped>
.menu-item
    height: 60px
    display: flex
    position: relative
    align-items: center
    padding-left: 20px
    padding-right: 20px
    text-align: center
    color: $color-secondary
    &:after
        content: ""
        position: absolute
        bottom: 0
        left: 0
        width: 100%
        height: 5px
        background: white
        transition: background-color .15s ease

.active
    &:after
        content: ""
        position: absolute
        bottom: 0
        left: 0
        width: 100%
        height: 5px
        background: $color-main
        +r(1140)
            border-bottom: 5px solid $color-main
</style>
